import React, { useEffect, useState } from "react";

import { deleteObject, ref } from "firebase/storage";
import { motion } from "framer-motion";
import { useRef } from "react";
import { NavLink } from "react-router-dom";
import { deleteConcept, getAllConcepts } from "../../api";
import { FaEdit, FaHeart, FaThumbsUp, MdDelete } from "../../assets/icons";
import { storage } from "../../config/firebase.config";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { buttonClick, fadeInOut } from "../../utils/animations";
import { Avatar } from "../../assets";

const Concepts = () => {
  const [index, setIndex] = useState(100);
  const [{ allConcepts, mainLoader }, dispatch] = useStateValue();
  const effectRun = useRef();

  useEffect(() => {
    // if (effectRun.current === true) {
    if (!allConcepts) {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

      getAllConcepts().then((concept) => {
        dispatch({
          type: actionType.SET_CONCEPTS,
          allConcepts: concept.data,
        });
      });

      setTimeout(() => {
        dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
      }, 3000);
    }
    // }
    return () => {
      // effectRun.current = true;
    };
  }, []);

  return (
    <div className=" w-full my-8 flex flex-col items-center justify-center">
      <div className="w-full flex items-center justify-between">
        <div></div>
        <p className="text-3xl text-headingColor font-semibold">
          List of concepts
        </p>
        <NavLink to={"/dashboard/newConcept"}>
          <motion.div
            {...buttonClick}
            className=" px-5 py-2  rounded-md border border-gray-200 bg-gray-50 cursor-pointer hover:shadow-lg"
          >
            Add New
          </motion.div>
        </NavLink>
      </div>
      <div className=" w-full my-4 border border-gray-200 min-w-full overflow-x-scroll p-2 rounded-md flex flex-wrap items-center justify-evenly gap-3">
        {allConcepts &&
          allConcepts
            ?.slice(0, index)
            .map((data, i) => <ConceptCard key={i} data={data} />)}
      </div>
      {allConcepts?.length > 100 && (
        <div className="w-full flex items-center justify-center mt-4">
          <p
            className="px-8 py-2 rounded-full bg-card shadow-md mb-32 cursor-pointer"
            onClick={() => setIndex(index + 100)}
          >
            Load More
          </p>
        </div>
      )}
    </div>
  );
};

export const ConceptCard = ({ data }) => {
  const [isDelete, setIsDelete] = useState(false);
  const [{ mainLoader, allConcepts, alertState, alertType }, dispatch] =
    useStateValue();

  const deleteMyData = () => {
    dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

    const deletRef = ref(storage, data?.video_thumb);
    deleteObject(deletRef)
      .then(() => {
        deleteConcept(data?.concept_id).then(() => {
          dispatch({
            type: actionType.SET_ALERT_TYPE,
            alertType: "successDelete",
          });
          dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

          getAllConcepts().then((concept) => {
            dispatch({
              type: actionType.SET_CONCEPTS,
              allConcepts: concept.data,
            });
          });

          setTimeout(() => {
            dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });

            dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
            dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
            setIsDelete(!isDelete);
          }, 3000);
        });
      })
      .catch((err) => {
        dispatch({
          type: actionType.SET_ALERT_TYPE,
          alertType: "danger",
        });
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

        setTimeout(() => {
          dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });

          dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
          dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
          setIsDelete(!isDelete);
        }, 3000);
      });
  };

  return (
    <div className="bg-card px-4 py-2 w-full sm:w-460 max-w-[460px] min-h-[100px] rounded-md hover:shadow-md cursor-pointer flex items-start justify-start gap-3 relative">
      <div className="gap-2 flex flex-col items-center justify-between">
        <img
          className=" w-28 min-w-[112px] rounded-md object-cover shadow-md"
          src={data?.video_thumb}
        />
        <div className="flex items-center justify-center gap-2 mt-auto">
          <p className="text-textColor font-semibold  flex items-center justify-center gap-2 text-sm">
            <FaThumbsUp className="-rotate-0 text-blue-500 text-sm" />
            32k
          </p>

          <p className="text-textColor font-semibold  flex items-center justify-center gap-2 text-sm">
            <FaHeart className="-rotate-0 text-red-500 text-sm" />
            32k
          </p>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-3">
        <p className="text-md font-semibold text-textColor">
          {data?.video_name}
        </p>
        <div className=" flex items-center justify-between w-full">
          <div className="flex items-center justify-center gap-2">
            <img
              src={data?.trainer?.thumb ? data?.trainer.thumb : Avatar}
              className="w-6 h-6 rounded-md object-cover"
              referrerPolicy="no-referrer"
            />
            <p className="text-textColor">{data?.trainer?.name}</p>
          </div>

          <div className="flex items-center justify-center gap-2">
            <motion.div {...buttonClick}>
              <FaEdit className="-rotate-0 text-green-500 text-2xl" />
            </motion.div>
            <motion.div {...buttonClick} onClick={() => setIsDelete(!isDelete)}>
              <MdDelete className="-rotate-0 text-red-500 text-2xl" />
            </motion.div>
          </div>
        </div>
      </div>

      {isDelete && (
        <motion.div
          {...fadeInOut}
          className="absolute inset-0 backdrop-blur-md flex flex-col items-center justify-center gap-3"
        >
          <p className="text-lg text-textColor font-semibold">
            Are you sure! do you want to delete this content?
          </p>
          <div className="flex items-center justify-center gap-8">
            <motion.button
              {...buttonClick}
              className="outline-none border-none bg-green-500 text-white text-base font-semibold px-6 py-1 rounded-md cursor-pointer shadow-md"
              onClick={deleteMyData}
            >
              Yes
            </motion.button>

            <motion.button
              {...buttonClick}
              className="outline-none border-none bg-red-500 text-white text-base font-semibold px-6 py-1 rounded-md cursor-pointer shadow-md"
              onClick={() => setIsDelete(!isDelete)}
            >
              No
            </motion.button>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Concepts;
